import React, { useMemo } from 'react';
import ReactCountryFlag from 'react-country-flag';
import { searchByIso } from '../../utils/countries';

export interface EmojiFlagProps {
  className?: string;
  iso?: string;
}

export const EmojiFlag: React.FC<EmojiFlagProps> = ({ className, iso }) => {
  const country = useMemo((): Country | null => {
    if (iso) {
      return searchByIso(iso);
    }

    return null;
  }, [iso]);

  const supportsEmojiFlag = useMemo(() => {
    if (typeof window === 'undefined' || !country) return true;

    const canvas = document.createElement('canvas');
    canvas.height = 10;
    canvas.width = canvas.height * 2;
    const ctx = canvas.getContext('2d') || ({} as any);
    ctx.font = `${canvas.height}px Arial`;
    ctx.fillText(country.flag, 0, canvas.height);
    const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height);
    let i = 0;
    while (i < data.length) {
      if (data[i] !== data[i + 1] || data[i] !== data[i + 2]) return true;
      i += 4;
    }
    return false;
  }, [country]);

  return country ? (
    <ReactCountryFlag
      className={className}
      countryCode={country?.iso || ''}
      svg={!supportsEmojiFlag}
      aria-label={`${country.country} flag`}
    />
  ) : (
    <span className={className}>{iso}</span>
  );
};
